import React from 'react'
import './AIBadge.scss'

interface AIBadgeProps {
  className?: string
}

const AIBadge = ({ className = '' }: AIBadgeProps) => {
  return (
    <span className={`ai-badge${className ? ` ${className}` : ''}`}>AI</span>
  )
}

export default AIBadge
